var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("健康在线")]),
              _c("el-breadcrumb-item", [_vm._v("文章管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.listParams, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类：", prop: "categoryId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择分类",
                              },
                              on: { change: _vm.handleCategoryChange },
                              model: {
                                value: _vm.listParams.categoryId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "categoryId", $$v)
                                },
                                expression: "listParams.categoryId",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标签：", prop: "categoryTagId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择标签",
                              },
                              model: {
                                value: _vm.listParams.categoryTagId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "categoryTagId", $$v)
                                },
                                expression: "listParams.categoryTagId",
                              },
                            },
                            _vm._l(_vm.categoryTagList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.tagName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态：", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择状态",
                              },
                              model: {
                                value: _vm.listParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "status", $$v)
                                },
                                expression: "listParams.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题：", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入文章标题" },
                            model: {
                              value: _vm.listParams.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "title", $$v)
                              },
                              expression: "listParams.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: " " } },
                        [
                          _c("el-button", { on: { click: _vm.resetForm } }, [
                            _vm._v("重置"),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v("新增文章")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "序号", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "categoryName",
                  align: "center",
                  label: "分类名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "categoryTagName",
                  align: "center",
                  label: "标签名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "文章名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#22bb52" } }, [
                          _vm._v(_vm._s(scope.row.title)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "readNum", align: "center", label: "阅读量" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.status === 0,
                                expression: "scope.row.status === 0",
                              },
                            ],
                          },
                          [_vm._v("草稿")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.status === 1,
                                expression: "scope.row.status === 1",
                              },
                            ],
                            staticStyle: { color: "#22bb52" },
                          },
                          [_vm._v("启用")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.status === 2,
                                expression: "scope.row.status === 2",
                              },
                            ],
                            staticStyle: { color: "#ffa500" },
                          },
                          [_vm._v("禁用")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "source", align: "center", label: "来源" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "排序" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        scope.row.status === 0 || scope.row.status === 2
                          ? _c(
                              "confirm-button",
                              {
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  type: "text",
                                  title: "确认要启用该条数据？",
                                },
                                on: {
                                  confirmed: function ($event) {
                                    return _vm.changeRowStatus(scope.row.id, 1)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("启用")])]
                            )
                          : _vm._e(),
                        scope.row.status === 1
                          ? _c(
                              "confirm-button",
                              {
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  type: "text",
                                  title: "确认要禁用该条数据？",
                                },
                                on: {
                                  confirmed: function ($event) {
                                    return _vm.changeRowStatus(scope.row.id, 2)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("禁用")])]
                            )
                          : _vm._e(),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteRow(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              attrs: {
                model: _vm.dialogParams,
                rules: _vm.dialogRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "categoryId", label: "分类：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择分类" },
                      on: { change: _vm.handleCategoryChange },
                      model: {
                        value: _vm.dialogParams.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogParams, "categoryId", $$v)
                        },
                        expression: "dialogParams.categoryId",
                      },
                    },
                    _vm._l(_vm.categoryList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签：", prop: "categoryTagId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择标签" },
                      model: {
                        value: _vm.dialogParams.categoryTagId,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogParams, "categoryTagId", $$v)
                        },
                        expression: "dialogParams.categoryTagId",
                      },
                    },
                    _vm._l(_vm.categoryTagListOfNew, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.tagName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标题：", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入文章标题" },
                    model: {
                      value: _vm.dialogParams.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogParams, "title", $$v)
                      },
                      expression: "dialogParams.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文章缩略图：", prop: "thumbnail" } },
                [
                  _c("oss-uploader", {
                    attrs: { previewList: _vm.previewList },
                    on: { setImage: _vm.getThumbnailImage },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文章内容：", prop: "html" } },
                [
                  _vm.dialogVisible
                    ? _c("RichTextarea", {
                        staticClass: "wang-editor-style",
                        attrs: { height: "400px" },
                        model: {
                          value: _vm.dialogParams.html,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogParams, "html", $$v)
                          },
                          expression: "dialogParams.html",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文章来源：", prop: "source" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入文章来源" },
                    model: {
                      value: _vm.dialogParams.source,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogParams, "source", $$v)
                      },
                      expression: "dialogParams.source",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "显示标签文字：", prop: "frontLabel" } },
                [
                  _vm._l(_vm.dynamicTags, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag,
                        attrs: { closable: "", "disable-transitions": false },
                        on: {
                          close: function ($event) {
                            return _vm.handleClose(tag)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tag) + " ")]
                    )
                  }),
                  _vm.inputVisible
                    ? _c("el-input", {
                        ref: "saveTagInput",
                        staticClass: "input-new-tag",
                        attrs: { size: "small" },
                        on: { blur: _vm.handleInputConfirm },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleInputConfirm.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.inputValue,
                          callback: function ($$v) {
                            _vm.inputValue = $$v
                          },
                          expression: "inputValue",
                        },
                      })
                    : _c(
                        "el-button",
                        {
                          staticClass: "button-new-tag",
                          attrs: { size: "small" },
                          on: { click: _vm.showInput },
                        },
                        [_vm._v("+ 标签")]
                      ),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序：", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { placeholder: "请输入排序", min: 1 },
                    model: {
                      value: _vm.dialogParams.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogParams, "sort", $$v)
                      },
                      expression: "dialogParams.sort",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: " " } }, [
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c("el-button", { on: { click: _vm.dialogCancel } }, [
                      _vm._v("取消"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isDisabled },
                        on: { click: _vm.dialogConfirm },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }